<template>
  <v-card elevation="0" outlined class="d-flex flex-column h-100" min-height="350">
    <v-card-title class="pb-0">
      <v-icon color="secondary" large class="mr-2">flare</v-icon>
      <div class="d-flex flex-column">
        <span class="primary--text monospace-font body-1 font-weight-medium">{{ $t("scoutingAnalysis.scoutingAnalyses") }}</span>
        <span class="subheader-font body-2">{{ $t("scoutingAnalysis.widgetSubtitle") }}</span>
      </div>
    </v-card-title>
    <v-card-text class="d-flex flex-column pb-1 overflow-auto flex-grow-1">
      <v-data-table dense disable-items-per-page multi-sort
        :headers="headers" 
        :items="analyses"
        :footer-props="{ itemsPerPageOptions: $vuetify.breakpoint.smAndDown ? [1] : [5]}"
        sort-by="tsUpdated" :sort-desc="true"
      >
        <!--Player-->
        <template v-slot:item.playerId="{ item }">
          <router-link :to="`/player/${item.playerId}/scouting-analysis`">
            <span class="text-ellipsis body-1">{{ item.playerName }}</span>
          </router-link>
        </template>
        <!--Global Rating-->
        <template v-slot:item.finalRating="{ item }">
          <div class="ma-0 py-1">
            <v-chip small :color="getRankingColor(item.finalRating)" class="monospace-font">{{ item.finalRating }}</v-chip>
          </div>
        </template>
        <!--Recommendation-->
        <template v-slot:item.recommendationId="{ item }">
          <span class="text-ellipsis body-2 monospace-font">{{ item.recommendation.text }}</span>
        </template>
        <!--Scout-->
        <template v-slot:item.createdById="{ item }">
          <span class="text-ellipsis body-1">{{ item.createdByName }}</span>
        </template>
        <!--Visibility-->
        <template v-slot:item.visibilityId="{ item }" >
          <span class="body-1"><v-icon class="me-1" x-small>{{ item.visibility.icon }}</v-icon>{{ item.visibility.name }}</span>
        </template>
        <!--TS-->
        <template v-slot:item.tsUpdated="{ item }" >
          <span class="body-1">{{ formatTimestamp(item.tsUpdated) }}</span>
        </template>
      </v-data-table>
      <v-divider class="mt-1"></v-divider>
    </v-card-text>
    <v-card-actions class="justify-end flex-shrink-0">
      <v-btn color="secondary" class="elevation-0 monospace-font white--text px-5" rounded small :to="`/library`">{{$t('library.goToLibrary')}}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>

import ResizeObserver from 'resize-observer-polyfill';
import * as _ from 'lodash';
import moment from 'moment';
import ScoutingAnalysisService from '../../../services/scoutingAnalysis.service';
import { colorScale } from '../../../utils/functions';

export default {
  name: "LastScoutingAnalysesWidget",
  data() {
    return {
      loading: false,
      observer: null,
      analyses: [],
      headers: [
        {
          text: this.$t("general.player"),
          value: "playerId",
          align: "start",
          sortable: false,
        },
        {
          text: this.$t("scoutingAnalysis.globalRating"),
          value: "finalRating",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("documents.recommendation.label"),
          value: "recommendationId",
          align: "start",
          sortable: false,
        },
        {
          text: this.$t("scoutingAnalysis.scouter"),
          value: "createdById",
          align: "start",
          sortable: false,
        },
        {
          text: this.$t("collections.visibility"),
          value: "visibilityId",
          align: "start",
          sortable: false,
        },
        {
          text: this.$t('scoutingAnalysis.lastEdited'),
          align: "start",
          value: "tsUpdated",
          sortable: false,
        },
      ],
      recommendationItems: [{ id: 1, text: this.$t('documents.recommendation.1') }, 
        { id: 2, text: this.$t('documents.recommendation.2') }, 
        { id: 3, text: this.$t('documents.recommendation.3') },
        { id: 4, text: this.$t('documents.recommendation.4') }],
      visibilities: [{ id: 1, name: this.$t('collections.privacity.publicTitle'), icon: 'public', description: 'publicDescription' }, 
        { id: 3, name: this.$t('collections.privacity.supervisedTitle'), icon: 'visibility', description: 'supervisedDescription' }, 
        { id: 2, name: this.$t('collections.privacity.privateTitle'), icon: 'lock', description: 'privateDescription' }],
    }
  },
  computed: {
  },
  async created() {
    await this.loadScoutingAnalyses();
  },
  mounted() {
    this.observer = new ResizeObserver(this.onResize).observe(this.$el);
  },
  methods: {
    onResize () {
      this.$emit('heightChange', this.$el.clientHeight)
    },
    async loadScoutingAnalyses() {
      this.loading = true;
      const analysesData = await ScoutingAnalysisService.getPlayerScoutingAnalysis();
      this.analyses = analysesData.data.map(a => {
        a.seeNotes = false;
        a.recommendation = this.recommendationItems.filter(r => a.recommendationId === r.id)[0];  
        a.visibility = this.visibilities.filter(v => a.visibilityId === v.id)[0];   
        a.updatedAt = moment(a.tsUpdated).format("DD/MM/YYYY HH:mm");
        return a;
      });
      this.loading = false;
    },
    getRankingColor(value) {
      if (value) return colorScale(1, 10, value, 90);
    },
    formatTimestamp(date) {
      const formattedDate = moment(date).format("DD/MM/YYYY");
      return formattedDate;
    },
  },
  destroyed () {
    delete this.observer;
  }
};
</script>



// WEBPACK FOOTER //
// src/views/dashboard/widgets/LastScoutingAnalysesWidget.vue